import { useMutation, useQuery } from '@tanstack/react-query';
import { get, post } from 'utils/axios';
import { DOMAIN_HINT, PERMISSIONS, WORKSPACES } from 'config/endpoints';
import {
  DomainHintPayload,
  DomainHintResponse,
  PermissionsResonse,
  Workspace,
} from 'types/usersAndPermissions.contract';
import { GenericQueryOptions } from './types/users-and-permissions';
import * as constants from 'config/constants';

export const useWorkspaceQuery = (queryOptions?: GenericQueryOptions<Workspace[]>) => {
  return useQuery(['WORKSPACE'], get<Workspace[]>(WORKSPACES), queryOptions);
};
export const usePermissionsQuery = (queryOptions?: GenericQueryOptions<PermissionsResonse>) => {
  return useQuery(['USER PERMISSIONS'], get<PermissionsResonse>(PERMISSIONS), queryOptions);
};
export const useDomainHintMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (email: string, domainHint: string) => void;
  onError?: (error: unknown) => void;
}) => {
  return useMutation(
    (email: string) =>
      post<DomainHintPayload, DomainHintResponse>(DOMAIN_HINT, { payload: { username: email } }),
    {
      onSuccess: (response, variables) => {
        if (onSuccess) {
          localStorage.setItem(constants.B2C_LOCAL_STORAGE_DOMAIN_HINT, response.data.domain_hint);
          localStorage.setItem(constants.B2C_LOCAL_STORAGE_EMAIL, variables);
          onSuccess(variables, response.data.domain_hint);
        }
      },
      onError,
    },
  );
};
